module.exports = __webpack_public_path__ + "static/media/headLogo.ddb59537.png";